import StarsIcon from "@mui/icons-material/Stars";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import Typography from "@mui/material/Typography";

import { formatDate } from "../../../helpers/dates";
import { replaceNewLinesWithBr } from "../../../helpers/string";
import { VehicleSettlementSurveyResponse } from "../../../types/Survey";

const VehicleSettlementSurveyResponseCard = ({
  response,
  displayAccount,
  onClick,
}: {
  response: VehicleSettlementSurveyResponse;
  displayAccount?: boolean;
  onClick?: () => void;
}) => {
  // const color = statusToColor[status];

  const renderStars = (stars: number) => {
    return (
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {Array.from({ length: stars }).map((_, index) => (
          <StarsIcon
            fontSize="small"
            key={index}
            sx={{ color: "tertiaryGreen.main" }}
          />
        ))}
      </Box>
    );
  };

  return (
    <Card
      sx={{
        display: "flex",
        flex: 1,
        width: "100%",
      }}
      variant="outlined"
    >
      <CardActionArea
        color="primary"
        sx={{
          display: "flex",
          backgroundColor: "surface.main",
          p: 2,
        }}
        disableRipple={true}
        onClick={onClick}
      >
        <Box
          sx={{
            display: "flex",
            flex: 1,
            flexDirection: "column",
            alignItems: "flex-start",
            textAlign: "left",
            py: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-end",
              width: "100%",
            }}
          >
            <Box>
              <Typography variant="titleMedium" color="primary">
                {response.crmContactName}
              </Typography>

              {displayAccount && response.crmAccountName && (
                <Typography variant="bodySmall" color="onSurface.main" mt={0.5}>
                  {response.crmAccountName}
                </Typography>
              )}
            </Box>

            {response.completedDate && (
              <Box>
                <Typography variant="bodySmall" color="onSurface.main">
                  {formatDate(response.completedDate)}
                </Typography>
              </Box>
            )}
          </Box>

          <Box
            my={1.5}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
            }}
          >
            <Typography variant="bodySmall" color="onSurface.main">
              <div
                dangerouslySetInnerHTML={{
                  __html: replaceNewLinesWithBr(response.likemost || ""),
                }}
              />
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 1,
            }}
          >
            {renderStars(response.userexperience)}
            <Typography variant="bodySmall" color="onSurface.main">
              Experience
            </Typography>
          </Box>
        </Box>
      </CardActionArea>
    </Card>
  );
};

export default VehicleSettlementSurveyResponseCard;
